import apiRequestService from '@/commonProject/service/apiRequestService';

export default class VendorRepository {
    /**
     * ベンダー情報取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getVendorApi(API_URL, queryParam) {
        const result = await apiRequestService.requestServerGet(API_URL + '/vnd', queryParam, null);
        return result;
    }
}
